import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import './assets/css/index.css';
import VueI18n from "vue-i18n";
import Typewriter from 'vue-typewriter'
Vue.use(Typewriter);
new Vue({el: '#root'});
Vue.use(VueI18n);
import messages from "./helper/translate";
import Notifications from "vt-notifications";
import VueMarqueeSlider from 'vue-marquee-slider';
Vue.use(Notifications);
import VueTyperPlugin from 'vue-typer'
Vue.use(VueTyperPlugin),
Vue.use(VueMarqueeSlider),
Vue.config.productionTip = false;
import CursorFx from '@luxdamore/vue-cursor-fx';
import '@luxdamore/vue-cursor-fx/dist/CursorFx.css';
    Vue.use(
        CursorFx
    );
const i18n = new VueI18n({
  lazy: true,
  locale: "mn",
  messages,
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')

